import { Fragment } from 'react';
import { Button } from '../../components/Button';
import { Checkbox } from '../../components/Checkbox';
import { FormCard } from '../../components/FormCard';
import { FormField } from '../../components/FormField';
import { TextInput } from '../../components/FormField/FormField.styles';
import { TextArea } from '../../components/TextArea';
import {
  ButtonGroup,
  FreeTextWrapper,
  LabelRow,
  LabelText,
  OtherInputWrapper,
  Panel,
  PreferencesSection,
} from './PreferencesPanel.styles';
import type { PreferencesPanelProps } from './PreferencesPanel.types';

export function PreferencesPanel({
  categories,
  onOptionToggle,
  onOtherChange,
  onFreeTextChange,
  onExpandedChange,
  otherButtonLabel = 'Other',
}: PreferencesPanelProps) {
  return (
    <Panel>
      {categories.map((category) => {
        const isOtherSelected = category.selectedOptions?.includes(otherButtonLabel);
        const isFreeText =
          category.isFreeText || !category.options || category.options.length === 0;
        const isCollapsed = category.collapsible && !category.expanded;

        return (
          <PreferencesSection key={category.id}>
            <LabelRow>
              <LabelText>{category.label}</LabelText>
              {category.collapsible && (
                <Checkbox
                  checked={!!category.expanded}
                  onChange={(expanded) => onExpandedChange?.(category.id, expanded)}
                  aria-label={category.label}
                  aria-expanded={!!category.expanded}
                />
              )}
            </LabelRow>

            {isCollapsed ? null : isFreeText ? (
              <FreeTextWrapper>
                <TextArea
                  aria-label={category.label}
                  rows={1}
                  placeholder={category.freeTextPlaceholder}
                  value={category.freeTextValue || ''}
                  onChange={(e) => onFreeTextChange(category.id, e.target.value)}
                />
              </FreeTextWrapper>
            ) : (
              <Fragment>
                <ButtonGroup>
                  {category.options?.map((option) => (
                    <Button
                      key={option}
                      variant="toggle"
                      size="small"
                      selected={category.selectedOptions?.includes(option)}
                      onClick={() => onOptionToggle(category.id, option)}
                      type="button"
                    >
                      {option}
                    </Button>
                  ))}
                  {category.allowOther !== false &&
                    !category.options?.includes(otherButtonLabel) && (
                      <Button
                        variant="toggle"
                        size="small"
                        selected={isOtherSelected}
                        onClick={() => onOptionToggle(category.id, otherButtonLabel)}
                        type="button"
                      >
                        {otherButtonLabel}
                      </Button>
                    )}
                </ButtonGroup>
                {category.allowOther !== false && isOtherSelected && (
                  <OtherInputWrapper>
                    <FormCard>
                      <FormField label={category.otherLabel || category.label}>
                        <TextInput
                          value={category.otherValue || ''}
                          onChange={(e) => onOtherChange(category.id, e.target.value)}
                        />
                      </FormField>
                    </FormCard>
                  </OtherInputWrapper>
                )}
              </Fragment>
            )}
          </PreferencesSection>
        );
      })}
    </Panel>
  );
}
